import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import { AuthProvider }            from './context/AuthContext.tsx'
import { RealtimeProvider }        from './context/RealtimeContext.tsx'
import { ToastProvider }           from './context/ToastContext.tsx'
import { ActivityProvider }        from './context/ActivityContext.tsx'
import { GoogleCalendarProvider }  from './context/GoogleCalendarContext.tsx'
import { DateRangeProvider }        from './context/DateRangeContext.tsx'
import './index.css'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <AuthProvider>
      <RealtimeProvider>
        <ToastProvider>
          <ActivityProvider>
            <GoogleCalendarProvider>
              <DateRangeProvider>
                <App />
              </DateRangeProvider>
            </GoogleCalendarProvider>
          </ActivityProvider>
        </ToastProvider>
      </RealtimeProvider>
    </AuthProvider>
  </React.StrictMode>,
)
